import { render, staticRenderFns } from "./CardAulaLista.vue?vue&type=template&id=19f7bbed&scoped=true&"
import script from "./CardAulaLista.vue?vue&type=script&lang=js&"
export * from "./CardAulaLista.vue?vue&type=script&lang=js&"
import style0 from "./CardAulaLista.vue?vue&type=style&index=0&id=19f7bbed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f7bbed",
  null
  
)

export default component.exports